"use client";

import { c as _c } from "react/compiler-runtime";
import { JobOpeningProps } from "@/lib/types";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { fadeInUp } from "@/lib/animation/variant";
import { isDeadlinePassed } from "@/lib/utils/date";
interface JobItemProps {
  job: JobOpeningProps;
  idx: number;
  onClick: (job: JobOpeningProps) => void;
}
const JobOpeningItem = t0 => {
  const $ = _c(27);
  const {
    job,
    onClick,
    idx
  } = t0;
  let t1;
  if ($[0] !== job.deadline) {
    t1 = isDeadlinePassed(job.deadline);
    $[0] = job.deadline;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const closed = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      once: true
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== job || $[4] !== onClick) {
    t3 = () => onClick(job);
    $[3] = job;
    $[4] = onClick;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = `group flex items-center justify-between lg:py-12 py-8 border-white/10 cursor-pointer transition-all duration-300 hover:px-4 ${idx === 0 ? "border-b border-t" : "border-b"}`;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="w-2 h-2 rounded-full bg-primary opacity-0 group-hover:opacity-100 transition-opacity shrink-0" />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `text-xl lg:text-2xl font-medium tracking-tight ${closed ? "text-white/40" : "text-white"}`;
  let t7;
  if ($[7] !== job.title || $[8] !== t6) {
    t7 = <h3 className={t6}>{job.title}</h3>;
    $[7] = job.title;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== closed) {
    t8 = closed && <span className="shrink-0 rounded-full border border-red-500/40 bg-red-500/10 px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-red-400">Now Closed</span>;
    $[10] = closed;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <div className="flex items-center gap-4">{t5}{t7}{t8}</div>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== job.location || $[16] !== job.type) {
    t10 = <span className="text-white/40 text-sm lg:text-base font-medium">{job.location} — {job.type}</span>;
    $[15] = job.location;
    $[16] = job.type;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ArrowUpRight className="text-white text-2xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10) {
    t12 = <div className="flex items-center gap-8">{t10}{t11}</div>;
    $[19] = t10;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== idx || $[22] !== t12 || $[23] !== t3 || $[24] !== t4 || $[25] !== t9) {
    t13 = <motion.div custom={idx} initial="hidden" whileInView="visible" viewport={t2} variants={fadeInUp} onClick={t3} className={t4}>{t9}{t12}</motion.div>;
    $[21] = idx;
    $[22] = t12;
    $[23] = t3;
    $[24] = t4;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};
export default JobOpeningItem;